import Arrow from "assets/svg/icons-new/arrow.svg";
import React from "react";
import { Link } from "react-router-dom";
import { HStack, Image, Text, Flex, CircularProgress } from "@chakra-ui/react";

export const AccountLink = ({
  to,
  icon,
  disabled,
  current,
  onClick,
  children,
  isLoading,
}) => {
  return (
    <Flex
      to={to}
      as={!disabled ? (!current ? (!onClick ? Link : Flex) : Flex) : Flex}
      p="20px"
      bg="white"
      onClick={onClick}
      borderRadius="16px"
      outline="1px solid transparent"
      disabled={disabled}
      _disabled={{
        opacity: 0.4,
        border: "none !important",
        boxShadow: "none !important",
      }}
      boxShadow={
        current
          ? "0 0 0 3px #06C3448f, 0 0 10px rgba(0,0,0,.05)"
          : "0 0 5px rgba(0,0,0,.05)"
      }
      border="2px solid transparent"
      borderColor={current ? "#06C344" : "transparent"}
      transition="all 300ms ease-in-out"
      _hover={{
        borderColor: "var(--primary)",
        cursor: disabled ? "not-allowed !important" : "pointer",
        // boxShadow: "0 0 0 3px #06C3448f, 0 0 10px rgba(0,0,0,.05)",
        transition: "all 300ms ease-in",
      }}
      _focus={{
        borderColor: "var(--primary)",
        transition: "all 300ms ease-in",
        boxShadow: "0 0 0 3px #06C3448f, 0 0 10px rgba(0,0,0,.05)",
      }}
    >
      <HStack justifyContent="space-between" w="100%">
        <HStack>
          <Image boxSize="28px" mr="1em" src={icon} />
          <Text
            letterSpacing="-0.5px"
            fontSize="16px"
            fontWeight="600"
            color="#14142B"
            ml="0 !important"
          >
            {children}
          </Text>
        </HStack>

        {!isLoading ? (
          <Image src={Arrow} />
        ) : (
          <CircularProgress size="16px" isIndeterminate color="green.400" />
        )}
      </HStack>
    </Flex>
  );
};

export default AccountLink;
